import {
  DateFieldAbsoluteFilter,
  DateFieldFilter,
  DateFieldFilterOperationType,
} from 'module/types/filter-field/filter/date';
import { humanise } from 'module/ui/components/atoms/humanised-date';
import { snakeCase } from 'lodash';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

const SelectedOptionRenderer = ({ filter }: { filter: DateFieldFilter }) => (
  <FormattedMessage
    id={`settings.integrations.sf.trigger.option.selected.${snakeCase(
      DateFieldFilterOperationType[filter.type],
    )}`}
    values={{
      format: humanise((filter as DateFieldAbsoluteFilter).value ?? moment()),
    }}
  />
);

export const dateTriggerOptionRenderers = (
  operationType: DateFieldFilterOperationType,
  filter?: DateFieldFilter,
): null | React.JSX.Element => {
  switch (operationType) {
    case DateFieldFilterOperationType.IsOn: {
      if (filter) {
        return <SelectedOptionRenderer filter={filter} />;
      }

      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_on" />
      );
    }

    case DateFieldFilterOperationType.IsAfter: {
      if (filter) {
        return <SelectedOptionRenderer filter={filter} />;
      }

      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_after" />
      );
    }

    case DateFieldFilterOperationType.IsBefore: {
      if (filter) {
        return <SelectedOptionRenderer filter={filter} />;
      }

      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_before" />
      );
    }

    case DateFieldFilterOperationType.IsEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_empty" />
      );
    }

    case DateFieldFilterOperationType.IsNotEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not_empty" />
      );
    }

    default: {
      return null;
    }
  }
};
